import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[620px] md:h-[750px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Japanese%20aesthetic%20background%20with%20soft%20warm%20cream%20tones%2C%20delicate%20cherry%20blossom%20petals%20floating%20gently%2C%20warm%20golden%20light%2C%20abstract%20artistic%20style%2C%20serene%20and%20sophisticated%20atmosphere%2C%20textured%20paper%20effect%2C%20high%20quality&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        alt="岛国精品 - 日本原装进口商品"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-accent-300 font-label text-xs md:text-sm tracking-[0.2em] uppercase mb-4 animate-fade-in">
            NIHON SEIHIN · JAPAN IMPORT
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight">
            {t('heroTitle')}
          </h1>
          <p className="text-background-100/90 text-base md:text-lg mb-3 max-w-2xl mx-auto leading-relaxed">
            {t('heroSubtitle')}
          </p>
          <p className="text-background-200/70 text-sm md:text-base mb-10 max-w-xl mx-auto leading-relaxed">
            {t('heroDescription')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              {t('heroCTA')}
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
            >
              {t('heroSecondaryCTA')}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}